module.exports = __webpack_public_path__ + "img/1440.09a85f42.jpg";